// Remember to import _form-fields.scss in your web-component styles
function getFieldStyles(props) {
  return {
    "field": true,
    "field--default": props.size === 'default',
    "field--large": props.size === 'large',
    "field--paragraph": props.size === 'paragraph',
    "field--disabled": props.disabled,
    "field--naked": props.naked,
    "field--error": props.error,
    "field--icon": props.error || props.valid || props.info,
    "field--icon--check": props.valid && !props.error,
    "field--icon--error": props.error,
    "field--icon--info": props.info && !props.error
  };
}
function getFieldTitleStyles(props) {
  return {
    "field__title": true,
    "field__title--default": props.size === "default",
    "field__title--large": props.size === "large" || props.size === "paragraph"
  };
}

export { getFieldStyles as a, getFieldTitleStyles as g };
